import SmartEdge from './SmartEdge';

export const edgeTypes = {
    smart: SmartEdge
};

export { SmartEdge };
